import React from 'react'
import Header from '../Home/header'
import Dashboard from './Dashboard'
import Hilalph from './Hilalph'
import Founding from './Founding'
import Areas from './Areas'
import Footer from '../Home/Footer'

export default function Index() {
  return (
    <>
      <Header/>
      <Dashboard/>
      <Hilalph/>
      <Footer/>
    </>
  )
}
